module.exports = __webpack_public_path__ + "img/ZB53详情页_11.90232e2d.jpg";